import Vue from 'vue'
import Vuex from 'vuex'
import Pinyin from 'pinyin/lib/web-pinyin'
import queryTable from './modules/queryTable'
import tagsView from './modules/tagsView'
import { API, HOME_MENUS, ENV } from 'public/config'
import { deepFreeze, defineFreezeProperty, createWatermarkStyle } from 'public/utils/common'
import ERPCache from 'public/utils/cache-plugin'
import bus from 'public/utils/bus'
import {
  getApiPermission,
  getSubsystemCodes,
  getProxyLookUpInStore,
  getProxyLookUpInWindow,
  handleMenus
} from './utils'

Vue.use(Vuex)

let store
let originLookUpOptions

const newStore = new Vuex.Store({
  state: {
    loading: false,
    avatar: '',
    user: {},
    menus: {},
    remindMenus: {},
    orgTree: {},
    gisProvinces: [],
    // departmentLabel: [],
    lookUpOptions: {},
    permission: Object.freeze({
      menus: getApiPermission(API),
      columns: [],
      sensitives: []
    }),
    globalMoneyFormatType: localStorage.getItem('GLOBAL_MONEY_FORMAT_TYPE') || 'ZH'
  },
  getters: {
    user: state => state.user,
    menus: state => state.menus,
    lookUpOptions: state => state.lookUpOptions,
    permission: state => state.permission,
    globalMoneyFormatType: state => state.globalMoneyFormatType
    // getDepartmentByLabelCode: (state) => (code) => {
    //   console.warn('[ERP]: 全局 store 的组织标签的方法已修改为[getDepartmentLabelByCodes],该方法即将下线请尽快替换')
    //   return state.departmentLabel.filter(v => v.labelCode === code)
    // },
  },
  modules: {
    queryTable,
    tagsView
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_PROVINCES(state, provinces) {
      state.gisProvinces = provinces
    },
    SET_USER(state, data) {
      if (!data.departmentInfo) {
        data.departmentInfo = { departmentRoute: '' }
      } else if (!data.departmentInfo.departmentRoute) {
        data.departmentInfo.departmentRoute = ''
      }
      let _departmentRoute = data.departmentInfo.departmentRoute
      // 只要组织路由中包含'销售管理部' 就属于总经办
      data.isGMO =
        _departmentRoute.includes('销售管理部') ||
        _departmentRoute.includes('销管中心') ||
        _departmentRoute.includes('营销管理部')

      // 如果有相应的数据字典，从数据字典再判断GMO
      let gmoLookup = window.__ERPLOOKUP__.filter(x => x.code === 'crm_filters_department')
      gmoLookup = gmoLookup.length ? gmoLookup[0].value : false
      if (Array.isArray(gmoLookup) && gmoLookup.length) {
        data.isGMO = gmoLookup.some(v => _departmentRoute.includes(v.lookupValue))
      }

      data.isMarket = data.duty === '市场员'
      data.isManager = data.duty === '经理'
      data.isMarketManager = data.duty === '销售主管'
      // 加密的 companyMobile privateMobile 处理为空字符
      if (data.companyMobile && !/^\d+$/.test(data.companyMobile)) {
        data.companyMobile = ''
      }
      if (data.privateMobile && !/^\d+$/.test(data.privateMobile)) {
        data.privateMobile = ''
      }
      state.user = deepFreeze(data)
      defineFreezeProperty(window, '__ERPUSER__', JSON.parse(JSON.stringify(data)))
      ERPCache.removeAllCache()
      createWatermarkStyle(data, +localStorage.svgFilter || 1)
    },
    SET_USER_AVATAR(state, data) {
      const employeeNumber = state.user.employeeNumber
      if (employeeNumber && data[employeeNumber]) {
        state.avatar = data[employeeNumber]
      } else {
        state.avatar = ''
      }
    },
    SET_PERMISSION(state, data) {
      data.menus = data['authMenuModuleCodes']
      data.columns = data['permissionColumnCodes']
      data.sensitives = data['sensitiveColumnCodes']
      delete data['authMenuModuleCodes']
      delete data['permissionColumnCodes']
      delete data['sensitiveColumnCodes']
      Object.keys(data).reduce((s, v) => {
        let arr = data[v]
        if (Array.isArray(arr)) {
          for (const k of arr) {
            s[v].push(k.toLowerCase())
          }
        }
        return s
      }, state.permission)
    },
    SET_PERMISSION_CODE(state, data) {
      data.menus = data['authMenuModuleCodes']
      data.columns = data['permissionColumnCodes']
      data.sensitives = data['sensitiveColumnCodes']
      delete data['authMenuModuleCodes']
      delete data['permissionColumnCodes']
      delete data['sensitiveColumnCodes']
      Object.keys(data).reduce((s, v) => {
        let arr = data[v]
        if (Array.isArray(arr)) {
          if (v === 'menus') {
            // 铸剑权限点比较大，需考虑数组循环的性能问题
            for (let i = 0; i < arr.length; i++) {
              s[v].push(arr[i])
            }
          } else {
            for (const k of arr) {
              s[v].push(k.toLowerCase())
            }
          }
        }
        return s
      }, state.permission)
    },
    INIT_PERMISSION(state) {
      state.permission.menus.splice(0, state.permission.menus.length - 1)
      state.permission.columns.splice(0, state.permission.columns.length - 1)
      state.permission.sensitives.splice(0, state.permission.sensitives.length - 1)
      getApiPermission(API).forEach(item => {
        state.permission.menus.push(item)
      })
    },
    SET_LOOKUP_OPTIONS(state, data) {
      let obj = data.reduce((o, v) => {
        let arr = v.value || v.childrenLookupValues
        if (arr && arr.length) {
          o[v.code] = arr
            .sort((a, b) => a.displaySequence - b.displaySequence)
            .map(v1 => ({ label: v1.lookupValue, value: v1.lookupCode, ext: v1.ext }))
        }
        return o
      }, {})
      if (obj['common_service_type']) {
        obj['common_service_type_active'] = obj['common_service_type'].filter(v => {
          if (!v.ext || !v.ext.startsWith('{')) return false
          try {
            v.ext = JSON.parse(v.ext)
            return v.ext.status === 10
          } catch (e) {
            return false
          }
        })
      }
      // 非生产环境才对数据字典进行监听上报
      if (ENV === 'prd') {
        state.lookUpOptions = Object.freeze(obj)
      } else {
        // 对 store 的数据字典进行代理监听 上报使用情况
        // 设置完 store 里面的数据字典数据后需要对 window 的数据字典进行代理监听（上报数据字典使用情况做分析使用，分析完可下架）
        // 添加延时后再代理，避免插件对 store 内容克隆导致的上报行为（例如：vue-devtool 会克隆数据）
        state.lookUpOptions = Object.freeze(obj)
        originLookUpOptions = Object.freeze(obj)
        window.__ERPLOOKUP__ = getProxyLookUpInWindow(window.__ERPLOOKUP__)
        setTimeout(() => {
          state.lookUpOptions = getProxyLookUpInStore(Object.freeze(obj))
        }, 5000)
      }
    },
    PATCH_LOOKUP_OPTIONS(state, data) {
      if (ENV === 'prd') {
        let obj = { ...state.lookUpOptions, ...data }
        state.lookUpOptions = Object.freeze(obj)
      } else {
        let obj = { ...originLookUpOptions, ...data }
        state.lookUpOptions = getProxyLookUpInStore(Object.freeze(obj))
      }
    },
    SET_MENUS(state, menus) {
      const subsystemCodes = getSubsystemCodes(window.__ERPLOOKUP__)
      const rootMenus = {}
      const obj = menus ? { menuTree: [] } : {}
      const en = { style: Pinyin.STYLE_FIRST_LETTER, segment: false }
      menus &&
        menus.forEach(v => {
          let subSystem = v.subSystem
          if (!subsystemCodes[subSystem] || rootMenus[v.id]) {
            return
          }
          let url = v.menuCode
          let title = v.menuTitle
          let menu = {
            id: v.id,
            menuCode: url,
            icon: v.menuIcon,
            subSystem: subSystem,
            component: v.component || '',
            label: title,
            title: title,
            $ptitle: subsystemCodes[subSystem],
            $title: title,
            $title_en:
              Pinyin(title, en)
                .map(v => v[0])
                .join('') || '',
            $kyeWord: v.keyWord || ''
          }
          if (v.childrenMenuResources && v.childrenMenuResources.length) {
            let children = []
            v.childrenMenuResources.forEach(v2 => {
              let curl = v2.menuCode
              if (obj[curl]) {
                return
              }
              let ctitle = v2.menuTitle
              let res = {
                id: v2.id,
                parentId: v2.parentId,
                menuCode: curl,
                icon: v2.menuIcon,
                subSystem: v2.subSystem,
                component: v2.component || '',
                label: ctitle,
                title: ctitle,
                $ptitle: subsystemCodes[v2.subSystem],
                $title: `${title} > ${ctitle}`,
                $title_en:
                  Pinyin(ctitle, en)
                    .map(v => v[0])
                    .join('') || '',
                $kyeWord: v2.keyWord || ''
              }
              if (!HOME_MENUS.includes(curl)) {
                children.push(res)
              }
              obj[curl] = res
            })
            menu.children = children
          } else if (!obj[url]) {
            obj[url] = menu
          }
          rootMenus[v.id] = menu
        })
      handleMenus(obj, rootMenus, subsystemCodes.codes, HOME_MENUS)
      state.menus = Object.freeze(obj)
    },
    SET_MENUS_REMIND(state, arr) {
      if (Array.isArray(arr) && arr.length) {
        let obj = arr.reduce((s, v) => {
          let menu = state.menus[v.key]
          if (menu) {
            s[v.key] = v.value
          }
          return s
        }, {})
        state.remindMenus = Object.freeze({ ...state.remindMenus, ...obj })
        bus.$emit('SET_MENUS_REMIND', arr)
      }
    },
    SET_DEPARTMENT_LABEL(state, data) {
      state.departmentLabel = Object.freeze(data)
    },
    SET_ORGTREE(state, data) {
      state.orgTree = Object.freeze(data)
    },
    SET_GLOBAL_MONEY_FORMAT_TYPE(state, type) {
      state.globalMoneyFormatType = type
      localStorage.setItem('GLOBAL_MONEY_FORMAT_TYPE', type)
    }
  }
})

if (window.__ERP_PUBLIC_SHARED_STORE__) {
  store = window.__ERP_PUBLIC_SHARED_STORE__
} else {
  window.__ERP_PUBLIC_SHARED_STORE__ = store = newStore
}

export default store



// WEBPACK FOOTER //
// ./src/public/store/index.js